import script from "./header-default.vue?vue&type=script&setup=true&lang=js"
export * from "./header-default.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=0d76851a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d76851a"]])

export default __exports__